import styled from 'styled-components';
import { Button, Label } from '../../../Components/uielements';
import { CloseIconRed } from '../../../Components/icons';

import { palette } from 'styled-theme';

export const MultistepFormWrapper = styled.div`
  display: grid;
  margin-top: 20px;
`;

export const ModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 30px 20px 20px;
  min-width: 450px;
  max-width: 600px;
  max-height: 550px;
  position: relative;
`;

export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  margin-top: 40px;
  justify-content: flex-end;
  gap: 10px;
  padding-bottom: 20px;
  position: sticky;
  bottom: 0px;
  background-color: transparent;
  z-index: 10;
`;

export const ModalButton = styled(Button)`
  width: fit-content !important;
  min-width: 100px !important;
`;

export const HeaderTitle = styled(Label)`
  font-weight: bold;
  font-size: 16px;
`;
export const QuestionTitle = styled(Label)`
  font-size: 15px;
`;

export const ClosedIcon = styled(CloseIconRed)`
  position: absolute;
  top: 5px;
  right: 0px;
  cursor: pointer;
  padding: 4px;
  width: 14px !important;
  height: 14px !important;
`;
